module.exports = __webpack_public_path__ + "img/game-one.45e2d248.png";